import { removeEmptyVals } from "helpers/helper";
import Request from "helpers/request";
import { useEffect, useReducer } from "react";


const initialState = {
  data: null,
  loading: false,
  error: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "loading":
      return { ...state, loading: action.payload };
    case "data":
      return { ...state, data: action.payload };
    case "error":
      return { ...state, error: action.payload };
    case "reset":
      return initialState;
    default:
      return state;
  }
};

export const useFetch = ({
  url = "", // Providing a default value for URL
  config = {},
  skip = false,
  errorPrefix = "",
  dependencyList = [],
  onCompleted = null,
  onError = null,
  filterConfig = true,
  cleanUp = () => {},
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const fetchData = async (runQueryURL, runQueryConfig = null) => {
    // NOTE: RESETTING TO INITIAL STATE ON EACH RENDER
    dispatch({
      type: "reset",
      payload: null,
    });

    dispatch({ type: "loading", payload: true });

    try {
      const filteredParams = filterConfig ? removeEmptyVals(runQueryConfig || config) : runQueryConfig || config;

      const res = await Request.get(runQueryURL || url, Object.keys(filteredParams)?.length > 0 ?  filteredParams : "");
      dispatch({ type: "data", payload: res?.data });

      if (onCompleted) {
        const returnedState = onCompleted(res?.data);
        if (returnedState) {
          dispatch({ type: "data", payload: returnedState });
        }
      }
      dispatch({ type: "loading", payload: false });
      return res;
    } catch (error) {
      const errorMsg =
        error?.response?.data?.detail?.message || "Something went wrong";
      dispatch({
        type: "error",
        payload: errorMsg,
      });
      dispatch({ type: "loading", payload: false });
      onError && onError(errorMsg);
      console.log(errorPrefix + errorMsg);
    }
  };

  useEffect(() => {
    if (url && url !== "" && !skip) {
      fetchData();
    }

    return () => {
      cleanUp();
    }
  }, [skip, url, ...dependencyList]);

  return { ...state, runQuery: fetchData };
};
 